import { Component, ViewEncapsulation } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { IdCardService } from "./id-card.service";
import * as idCardString from "../stringFiles/idCard.json";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ActivatedRoute } from '@angular/router';
import { BrandService } from '../brand/brand.service';

declare var $: any;
declare var customToastr: any;
@Component({
  selector: "app-id-card",
  templateUrl: "./id-card.component.html",
  styleUrls: [
    "./id-card.component.css",
    "../tc-generation/tc-generation.component.css",
    "./../../assets/css/theme-default/materialadmin.css",
    "./../../assets/css/theme-default/font-awesome.min.css",
    "./../../assets/css/theme-default/libs/bootstrap-datepicker/datepicker3.css",
    "./../../assets/css/theme-default/material-design-iconic-font.min.css",
    "./../../assets/css/theme-default/libs/DataTables/jquery.dataTables.css",
    "./../../assets/css/theme-default/libs/DataTables/extensions/dataTables.colVis.css",
    "./../../assets/css/theme-default/libs/DataTables/extensions/dataTables.tableTools.css",
    /*'./../../assets/css/theme-default/libs/toastr/toastr.css?1425466569',*/
    "./../../_crop/css/style.css",
    "./../tc-generation/tc-generation.component.css",
    "./../../_crop/css/style-example.css",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class IdCardComponent {
  strings: any;
  activeTab: string = 'student'; 
  isRefreshing : any = false;
  tcCancelling: boolean = false;
  editableTemplate: string = "";
  cancellationJobId: string = "";
  updatingList: boolean = false;
  idCardJobList: [];
  idCardTemplates = [];
  fetchingStudentList: boolean = false;
  fetchingStaffList: boolean = false;
  studentListForTc: [];
  staffListForTc:[];
  showPreview = false;
  selectedJobIdForPreview = "";
  selectedServiceId: any;
  isUploadingExcel: boolean = false;
  uploadingExcelSheet: boolean = false;
  tcUploadErrors = [];
  uploadSuccess: boolean = false;
  idCardJobId: any;
  initialLoading : any = true;
  isPageLoading = true;
  studentServiceEnabled: boolean = false;
staffServiceEnabled: boolean = false;
serviceDisabledMessage: string | null = null;
  brand = this.brandService.brand;

  constructor(private idService: IdCardService,private router : Router, private translate: TranslateService,  private route: ActivatedRoute, private brandService: BrandService) {
    this.strings = idCardString;
  }

 ngOnInit() {
  this.studentServiceEnabled = localStorage.getItem('idCardService') === 'true';
  this.staffServiceEnabled = localStorage.getItem('staffIdCardService') === 'true';

  // Subscribe to route params FIRST
  this.route.params.subscribe(params => {
    const tab = params['tab'];
    
    if (tab === 'staff' && this.staffServiceEnabled) {
      this.activeTab = 'staff';
      this.getStaffServiceList();
    } else if (tab === 'student' && this.studentServiceEnabled) {
      this.activeTab = 'student';
      this.getServiceList();
    } else {
      // Default fallback if no tab param or service not enabled
      if (!this.studentServiceEnabled && this.staffServiceEnabled) {
        this.activeTab = 'staff';
        this.getStaffServiceList();
      } else if (this.studentServiceEnabled) {
        this.activeTab = 'student';
        this.getServiceList();
      }
    }
  });
}

switchTab(tab: 'student' | 'staff') {
  if (tab === 'student' && !this.studentServiceEnabled) {
    this.activeTab = tab;
    this.showServiceDisabled('STUDENT');
    this.initialLoading = false;
    return;
  }
  if (tab === 'staff' && !this.staffServiceEnabled) {
    this.activeTab = tab;
    this.showServiceDisabled('STAFF');
    this.initialLoading = false;
    return;
  }
  this.initialLoading = true;
  this.serviceDisabledMessage = null;
  this.activeTab = tab;

  if (tab === 'student') {
        this.router.navigate(['/id-card', 'student']).then(() => {
      this.getServiceList(); 
    });
  } else if (tab === 'staff') {
         this.router.navigate(['/id-card', 'staff']).then(() => {
      this.getStaffServiceList(); 
    });
  }
}

showServiceDisabled(key: string) {
  this.activeTab = ''; 
  this.serviceDisabledMessage = key;
  this.clearPreviousData();
}

clearPreviousData() {
 this.idCardJobList = [];
 this.idCardTemplates = [];
}

  // function for get service list
  async getServiceList() {
    try {
          this.isPageLoading = true;
      const response: any = await firstValueFrom(
        this.idService.getServiceListData()
      );
      if (response.status) {
        this.idCardJobList = response.body.idCardDetails.idCardJobList;
        this.idCardTemplates = response.body.idCardDetails.idCardTemplateList;
      }
      this.initialLoading = false;
      this.isRefreshing = false;
          this.isPageLoading = false;
    } catch (error) {
      const somethingWentWrongMessageTranslation = await firstValueFrom(this.translate.get('somethingWentWrongMessage'))
      customToastr(error.error.message || somethingWentWrongMessageTranslation ,"error")
    }
  }

  async getStaffServiceList() {
     try {
      this.isPageLoading = true;
      const response: any = await firstValueFrom(
        this.idService.getStaffServiceListData()
      );
      if (response.status) {
        this.idCardJobList = response.body.idCardDetails.idCardJobList;
        this.idCardTemplates = response.body.idCardDetails.idCardTemplateList;
      }
      this.initialLoading = false;
      this.isPageLoading = false;
      this.isRefreshing = false;
    } catch (error) {
      const somethingWentWrongMessageTranslation = await firstValueFrom(this.translate.get('somethingWentWrongMessage'))
      customToastr(error.error.message || somethingWentWrongMessageTranslation ,"error")
    }
  }

  // function for refresh list
  refreshList() {
    this.isRefreshing = true;
    this.loadDataForActiveTab();
  }

loadDataForActiveTab() {
  
  if (this.activeTab === 'student') {
    this.getServiceList();
  } else if (this.activeTab === 'staff') {
    this.getStaffServiceList();
  }
}


  // function to create false from preview page
  handleBackArrowClick() {
    this.showPreview = false;
  }

  // Function for open pop up for edit selected job
  openPopUpForEditJob(selectedTemplate, jobId) {
    this.editableTemplate = selectedTemplate;
    this.cancellationJobId = jobId;
    $("#editJob").modal("show");
  }

  openPopUpForEditStaffJob(selectedTemplate, jobId) {
    this.editableTemplate = selectedTemplate;
    this.cancellationJobId = jobId;
    $("#staffEditJob").modal("show");
  }

  // function for close pop up edit
  closePopUpForEditJob() {
    $("#editJob").modal("hide");
  }

  closePopUpForStaffEditJob() {
    $("#staffEditJob").modal("hide");
  }

  // After click edit this function will run and download the template
 async downloadTemplateForEdit() {
    const link = document.createElement("a");
    link.href = this.editableTemplate;
    link.download = "template.xls";
    link.click();
    this.closePopUpForEditJob();
    const fileDownloadMessageTranslation = await firstValueFrom(this.translate.get('fileDownloadMessage'))
    customToastr(fileDownloadMessageTranslation, this.strings.success);
    this.cancelSelectedJob();
  }

  async downloadStaffTemplateForEdit() {
    const link = document.createElement("a");
    link.href = this.editableTemplate;
    link.download = "template.xls";
    link.click();
    this.closePopUpForStaffEditJob();
    const fileDownloadMessageTranslation = await firstValueFrom(this.translate.get('fileDownloadMessage'))
    customToastr(fileDownloadMessageTranslation, this.strings.success);
    this.cancelSelectedStaffJob();
  }

  // function for selection id card template for excel download
  openIdCardTemplate(event) {
    this.resetTemplateSelection();
    event.preventDefault();
    $("#idCardTemplate").modal("show");
  }

  // function for selection to upload excel
  openIdCardTemplateUpload(event) {
    this.resetTemplateSelection();
    event.preventDefault();
    $("#idCardTemplateForUpload").modal("show");
  }

  // function for close selection to upload excel
  closeIdCardTemplateUpload() {
    // this.resetTemplateSelection();
    $("#idCardTemplateForUpload").modal("hide");
  }

  // function for close selection to upload excel
  closeIdCardTemplate() {
    this.resetTemplateSelection();
    $("#idCardTemplate").modal("hide");
  }

  // function for selected cancel job
  async cancelSelectedJob() {
    try {
      this.tcCancelling = true;
      const response = await firstValueFrom(
        this.idService.idJobCancel(this.cancellationJobId)
      );
      const data = response as any;
      if (data.status && data.body) {
        this.closeJobCancellationPopup();
        const successTranslation = await firstValueFrom(this.translate.get('success'))
        customToastr(
          data.body
            ? data.body.message
              ? data.body.message
              : successTranslation
            : successTranslation,
          this.strings.success
        );
      }
      this.getServiceList();
      this.tcCancelling = false;
    } catch (error) {
      this.closeJobCancellationPopup();
      this.tcCancelling = false;
      if (error?.error?.message) {
        customToastr(error.error.message, this.strings.error);
      } else {
        const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'))
        customToastr(errorMessageTranslation, this.strings.error);
      }
    }
  }

  // function to cancel selected job for staff
  async cancelSelectedStaffJob() {
    try {
      this.tcCancelling = true;
      const response = await firstValueFrom(
        this.idService.staffIdJobCancel(this.cancellationJobId)
      );
      const data = response as any;
      if (data.status && data.body) {
        this.closeStaffJobCancellationPopup();
        const successTranslation = await firstValueFrom(this.translate.get('success'))
        customToastr(
          data.body
            ? data.body.message
              ? data.body.message
              : successTranslation
            : successTranslation,
          this.strings.success
        );
      }
      this.getStaffServiceList();
      this.tcCancelling = false;
    } catch (error) {
      this.closeJobCancellationPopup();
      this.tcCancelling = false;
      if (error?.error?.message) {
        customToastr(error.error.message, this.strings.error);
      } else {
        const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'))
        customToastr(errorMessageTranslation, this.strings.error);
      }
    }
  }

  // function for get student details
  async openStudentDetailsForTc(jobId) {
    try {
      this.fetchingStudentList = true;
      this.studentListForTc = [];
      $("#studentDetailsTc").modal("show");
      const response = await firstValueFrom(
        this.idService.getStudentListForId(jobId)
      );
      const data = response as any;
      if (data.status && data.body) {
        this.studentListForTc = data.body.studentDataForJob;
        this.fetchingStudentList = false;
      } else {
        this.studentListForTc = [];
        this.fetchingStudentList = false;
      }
    } catch (error) {
      this.closePopOfStudentList();
      this.studentListForTc = [];
      this.fetchingStudentList = false;
      if (error?.error?.message) {
        customToastr(error.error.message, this.strings.error);
      } else {
        const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'))
        customToastr(errorMessageTranslation, this.strings.error);
      }
    }
  }

   // function for get staff details
    async openStaffDetailsForIdCard(jobId) {
    try {
      this.fetchingStaffList = true;
      this.staffListForTc = [];
      $("#staffDetailsIdCard").modal("show");
      const response = await firstValueFrom(
        this.idService.getStaffListForId(jobId)
      );
      const data = response as any;
      if (data.status && data.body) {
        this.staffListForTc = data.body.staffDataForJob;
        this.fetchingStaffList = false;
      } else {
        this.staffListForTc = [];
        this.fetchingStaffList = false;
      }
    } catch (error) {
      this.closePopOfStaffList();
      this.staffListForTc = [];
      this.fetchingStaffList = false;
      if (error?.error?.message) {
        customToastr(error.error.message, this.strings.error);
      } else {
        const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'))
        customToastr(errorMessageTranslation, this.strings.error);
      }
    }
  }

  // function for close student details pop up
  closePopOfStudentList() {
    $("#studentDetailsTc").modal("hide");
  }

  closePopOfStaffList() {
    $("#staffDetailsIdCard").modal("hide");
  }

  // function for open details job preview
  handleViewButton(jobId: any, serviceId: any) {
    this.selectedServiceId = serviceId;
    this.selectedJobIdForPreview = jobId;
    this.showPreview = true;
  }

   // function for open details job preview (staff id card)
  handleStaffViewButton(jobId:any, serviceId:any) {
    this.selectedServiceId = serviceId;
    this.selectedJobIdForPreview = jobId;
    this.showPreview = true;
  }

  // function for cancel open scheduled job
  openPopUpForJobCancellation(jobId) {
    this.cancellationJobId = jobId;
    $("#cancelJob").modal("show");
  }

  // function for cancel open scheduled job for staff id card
    openPopUpForStaffJobCancellation(jobId) {
    this.cancellationJobId = jobId;
    $("#cancelStaffJob").modal("show");
  }

  // function for cancel close scheduled job
  closeJobCancellationPopup() {
    $("#cancelJob").modal("hide");
  }

  // function for cancel close scheduled job for staff id card
  closeStaffJobCancellationPopup() {
     $("#cancelStaffJob").modal("hide");
  }

  // function for provide selection mark
  selectIdCard(id: any) {
    console.log(this.idCardTemplates);
    this.idCardTemplates = this.idCardTemplates.map((data) => ({
      ...data,
      isSelected: data.templateId === id,
    }));
  }

  // function for return selected card
  getSelectedTemplate() {
    const data = this.idCardTemplates.find((data) => data.isSelected);
    return data;
  }

  // function for download selected template excel
 async downloadSelectedTemplate() {
    const link = document.createElement("a");
    link.href = this.getSelectedTemplate().sampleDocumentUrl;
    link.download = "template.xls";
    link.click();
    const fileDownloadMessageTranslation = await firstValueFrom(this.translate.get('fileDownloadMessage'))
    customToastr(fileDownloadMessageTranslation, this.strings.success);
    $("#idCardTemplate").modal("hide");
    this.resetTemplateSelection();
  }

  // function for open pop up for upload excel
  openPopUpForUploadingExcel() {
    $("#uploadingExcel").modal("show");
  }

  // function for close pop up for upload excel
  closePopUpForUploadingExcel() {
    $("#uploadingExcel").modal("hide");
  }

  // function for selection template for upload excel
  selectionTemplateForId() {
    $("#selectTemplateForUploadExcel").modal("show");
  }

  // function for upload excel to generate id card
  async fileUploadExcel(uploadedFile) {
    try {
      this.closeIdCardTemplateUpload();
      this.uploadingExcelSheet = true;
      this.tcUploadErrors = [];
      this.uploadSuccess = false;
      const file = uploadedFile.target.files[0];
      const allowFormats = ["xls", "xlsx"];
      const fileName = file.name;
      const fileExtension = fileName.split(".").pop().toLowerCase();
      if (!allowFormats.includes(fileExtension)) {
        const fileFormatErrorTranslation = await firstValueFrom(this.translate.get('fileFormatError'))
        customToastr(fileFormatErrorTranslation, this.strings.error);
        return;
      }
      if (!file) {
        const fileUploadErrorMessageTranslation = await firstValueFrom(this.translate.get('fileUploadErrorMessage'))
        customToastr(fileUploadErrorMessageTranslation, this.strings.error);
        return;
      }
      const maxSizeInMB = this.strings.fileSize;
      const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        customToastr(
          `File size exceeds the limit of ${maxSizeInMB}MB. Please upload a smaller file.`,
          this.strings.error
        );
        return;
      }

      const body = {
        lang: this.strings.lang,
        templateId: this.getSelectedTemplate().templateId,
      };
      this.openPopUpForUploadingExcel();
      this.isUploadingExcel = true;
      const response = await firstValueFrom(
        this.idService.uploadExcel(body, file)
      );
      const data = response as any;
      if (data && data.body) {
        if (data.status) {
          if (data.status_code === 412) {
            this.tcUploadErrors = data.body.errorList
              ? data.body.errorList
              : [];
            this.isUploadingExcel = false;
            this.uploadSuccess = false;
            this.uploadingExcelSheet = false;
          } else {
            this.idCardJobId = data.body.jobDetails
              ? data.body.jobDetails.jobId
                ? data.body.jobDetails.jobId
                : ""
              : "";
            this.uploadSuccess = true;
            this.isUploadingExcel = false;
            this.uploadingExcelSheet = false;
            this.getServiceList();
            this.resetTemplateSelection();
          }
        }
      }
    } catch (error) {
      this.uploadingExcelSheet = false;
      this.isUploadingExcel = false;
      if (error?.error?.message) {
        customToastr(error.error.message, this.strings.error);
      } else {
        const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'))
        customToastr(errorMessageTranslation, this.strings.error);
      }
    }
  }

  // function for upload excel to generate id card for staff
  async staffFileUploadExcel(uploadedFile) {
    try {
      this.closeIdCardTemplateUpload();
      this.uploadingExcelSheet = true;
      this.tcUploadErrors = [];
      this.uploadSuccess = false;
      const file = uploadedFile.target.files[0];
      const allowFormats = ["xls", "xlsx"];
      const fileName = file.name;
      const fileExtension = fileName.split(".").pop().toLowerCase();
      if (!allowFormats.includes(fileExtension)) {
        const fileFormatErrorTranslation = await firstValueFrom(this.translate.get('fileFormatError'))
        customToastr(fileFormatErrorTranslation, this.strings.error);
        return;
      }
      if (!file) {
        const fileUploadErrorMessageTranslation = await firstValueFrom(this.translate.get('fileUploadErrorMessage'))
        customToastr(fileUploadErrorMessageTranslation, this.strings.error);
        return;
      }
      const maxSizeInMB = this.strings.fileSize;
      const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        customToastr(
          `File size exceeds the limit of ${maxSizeInMB}MB. Please upload a smaller file.`,
          this.strings.error
        );
        return;
      }

      const body = {
        lang: this.strings.lang,
        templateId: this.getSelectedTemplate().templateId,
      };
      this.openPopUpForUploadingExcel();
      this.isUploadingExcel = true;
      const response = await firstValueFrom(
        this.idService.uploadExcelForStaff(body, file)
      );
      const data = response as any;
      if (data && data.body) {
        if (data.status) {
          if (data.status_code === 412) {
            this.tcUploadErrors = data.body.errorList
              ? data.body.errorList
              : [];
            this.isUploadingExcel = false;
            this.uploadSuccess = false;
            this.uploadingExcelSheet = false;
          } else {
            this.idCardJobId = data.body.jobDetails
              ? data.body.jobDetails.jobId
                ? data.body.jobDetails.jobId
                : ""
              : "";
            this.uploadSuccess = true;
            this.isUploadingExcel = false;
            this.uploadingExcelSheet = false;
            this.getStaffServiceList();
            this.resetTemplateSelection();
          }
        }
      }
    } catch (error) {
      this.uploadingExcelSheet = false;
      this.isUploadingExcel = false;
      if (error?.error?.message) {
        customToastr(error.error.message, this.strings.error);
      } else {
        const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'))
        customToastr(errorMessageTranslation, this.strings.error);
      }
    }
  }

  // function for reset template selection
  resetTemplateSelection() {
    this.idCardTemplates = this.idCardTemplates.map((template) => ({
      ...template,
      isSelected: false,
    }));
  }

  // for navigating to student page
  navigateToStudentPage(){
       this.router.navigate(["/groups", "student"]);
  }

   // for navigating to staff page
  navigateToStaffPage() {
   this.router.navigate(["/groups", "staff"]);
  }

}

